import React from 'react';

import withLocalization from '~/hoc/withLocalization';

const DEFAULT_STYLE = {
    background: '#2550AC', color: 'white', borderRadius: '2px',
    display: 'inline-flex', alignItems: 'center', justifyContent: 'center',
    width: '13px', height: '13px', fontSize: '9px', lineHeight: '1', padding: 0,
};

const FutureScheduleEntryBadge = ({ style, wrapperStyle, t }) => (
    <span title={t('Future Time Recording')} style={wrapperStyle}>
        <span style={{ ...DEFAULT_STYLE, ...style }}>
            <i className="fa fa-forward" aria-hidden="true"></i>
        </span>
    </span>
);

export default withLocalization(FutureScheduleEntryBadge);
